export default "__VITE_ASSET__17ea37d1__"